import { SEOData } from "@/types/seo";

const baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL?.replace(/\/$/, "");

export const generateBlogSEOData = (blogData?: any): SEOData => {
  const seo = blogData?.seo;
  const seoData: SEOData = {
    page_title:
      seo?.page_title ??
      blogData?.blog_title ??
      "Read Latest Blogs on Various Topics - CollegeHai",
    page_description:
      seo?.page_description ??
      blogData?.excerpt ??
      blogData?.description ??
      "Explore insightful blogs on various topics including education, career, study abroad, and college admissions.",
    page_canonical_url: `${baseUrl}/blogs/${blogData?.blog_url ?? ""}`,
    keywords:
      seo?.keywords ??
      "education blogs, study abroad tips, career guidance, college admissions",
    page_og_title:
      seo?.page_og_title ??
      seo?.page_title ??
      blogData?.blog_title ??
      "Latest Blogs - CollegeHai",
    page_og_description:
      seo?.page_og_description ??
      seo?.page_description ??
      blogData?.excerpt ??
      blogData?.description ??
      "Get valuable insights from our latest blogs on education, career planning, and study abroad opportunities.",
    page_og_url: `${baseUrl}/blogs/${blogData?.blog_url}`,
    twitter_title:
      seo?.twitter_title ??
      seo?.page_title ??
      blogData?.blog_title ??
      "Latest Blogs - CollegeHai",
    twitter_description:
      seo?.twitter_description ??
      seo?.page_description ??
      blogData?.excerpt ??
      blogData?.description ??
      "Explore our latest blogs on education, career growth, and study abroad tips.",
    twitter_image:
      blogData?.featured_image?.url ?? `${baseUrl}/images/logo.png`,
    twitter_image_alt:
      blogData?.featured_image?.name ?? "CollegeHai Blog Thumbnail",
    article_modified_time: blogData?.updatedAt ?? null,
    article_published_time: blogData?.publishedAt ?? null,
  };

  return seoData;
};
